import script from "./ExResSerAero.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExResSerAero.vue?vue&type=script&lang=ts&setup=true"

import "./ExResSerAero.vue?vue&type=style&index=0&id=35565ee2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35565ee2"]])

export default __exports__